import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { pageBySlug } from "../lib/sitePages";
import { useSeo } from "../lib/useSeo";

export default function SitePage({ slug }) {
  const { lang } = useI18n();
  const page = pageBySlug(slug);
  const title = page ? (page.title[lang] || page.title.es) : "Canarias Market";
  const body = page ? (page.body[lang] || page.body.es) : [];

  useSeo({ title: `${title} - Canarias Market`, description: body[0] || "" });

  return (
    <div className="px-4 py-8 sm:py-12 max-w-3xl mx-auto" data-testid={`site-page-${slug}`}>
      <Link to="/" data-testid="site-page-back" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#008080] transition-colors mb-5">
        <ChevronLeft className="h-4 w-4" /> Canarias Market
      </Link>
      <h1 className="font-display font-extrabold text-3xl sm:text-4xl text-slate-900">{title}</h1>
      <div className="mt-6 space-y-4 text-slate-600 leading-relaxed">
        {body.map((p, i) => <p key={i} data-testid={`site-page-para-${i}`}>{p}</p>)}
      </div>
    </div>
  );
}
